var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "insta",
    width: 31.562,
    height: 31.562,
    viewBox: "0 0 31.562 31.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#radial-gradient)}.cls-2{fill:#fff}\n        "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.291,
    cy: 0.947,
    r: 0.987,
    gradientTransform: "rotate(-66.28 .29 .947)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faab49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#f97e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#de376d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#b52f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a53eb8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    d: "M15.781 31.562A15.783 15.783 0 0 1 0 15.781 15.783 15.783 0 0 1 15.781 0a15.783 15.783 0 0 1 15.781 15.781 15.783 15.783 0 0 1-15.781 15.781z",
    className: "cls-1",
    "data-name": "Path 218"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(5.006 5.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    d: "M169.375 160.641c2.875 0 3.216.009 4.352.063a5.91 5.91 0 0 1 2 .372 3.563 3.563 0 0 1 2.042 2.042 5.992 5.992 0 0 1 .372 2c.051 1.136.063 1.477.063 4.352s-.009 3.216-.063 4.352a5.911 5.911 0 0 1-.372 2 3.563 3.563 0 0 1-2.042 2.042 5.992 5.992 0 0 1-2 .372c-1.136.05-1.477.063-4.352.063s-3.216-.009-4.352-.063a5.91 5.91 0 0 1-2-.372 3.563 3.563 0 0 1-2.042-2.042 5.992 5.992 0 0 1-.372-2c-.051-1.136-.063-1.477-.063-4.352s.009-3.216.063-4.352a5.911 5.911 0 0 1 .372-2 3.562 3.562 0 0 1 2.042-2.042 5.992 5.992 0 0 1 2-.372c1.136-.054 1.477-.063 4.352-.063m0-1.941c-2.926 0-3.292.013-4.441.066a7.918 7.918 0 0 0-2.616.5 5.2 5.2 0 0 0-1.906 1.24 5.3 5.3 0 0 0-1.244 1.909 7.965 7.965 0 0 0-.5 2.617c-.054 1.149-.066 1.515-.066 4.441s.013 3.292.066 4.441a7.918 7.918 0 0 0 .5 2.616 5.527 5.527 0 0 0 3.153 3.147 7.966 7.966 0 0 0 2.616.5c1.149.054 1.515.066 4.441.066s3.292-.013 4.441-.066a7.919 7.919 0 0 0 2.617-.5 5.527 5.527 0 0 0 3.147-3.153 7.965 7.965 0 0 0 .5-2.616c.054-1.149.066-1.515.066-4.441s-.013-3.292-.066-4.441a7.919 7.919 0 0 0-.5-2.616 5.527 5.527 0 0 0-3.153-3.147 7.965 7.965 0 0 0-2.616-.5c-1.146-.05-1.512-.063-4.438-.063z",
    className: "cls-2",
    "data-name": "Path 219",
    transform: "translate(-158.6 -158.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    d: "M330.233 324.7a5.533 5.533 0 1 0 5.533 5.533 5.533 5.533 0 0 0-5.533-5.533zm0 9.125a3.592 3.592 0 1 1 3.592-3.592 3.592 3.592 0 0 1-3.592 3.592z",
    className: "cls-2",
    "data-name": "Path 220",
    transform: "translate(-319.458 -319.461)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    cx: 1.294,
    cy: 1.294,
    className: "cls-2",
    "data-name": "Ellipse 10",
    rx: 1.294,
    ry: 1.294,
    transform: "translate(15.232 3.727)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.47862a9f317959c3d5fc29700d0ca6af.svg";
export { ForwardRef as ReactComponent };